var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.orderPutErrors },
        on: {
          "update:errors": function($event) {
            _vm.orderPutErrors = $event
          }
        }
      }),
      _c(
        "v-overlay",
        {
          attrs: {
            absolute: "",
            value: _vm.orderGetting || _vm.orderAttachInvoicePosting
          }
        },
        [
          _c("v-progress-circular", { attrs: { indeterminate: "", size: 100 } })
        ],
        1
      ),
      _c(
        "v-toolbar",
        { attrs: { color: "primary", dark: "", dense: "", elevation: "0" } },
        [
          _c("span", [_vm._v("Edit Order")]),
          _c("v-spacer"),
          !_vm.orderData.invoiceCount
            ? _c(
                "v-btn",
                {
                  staticClass: "mr-2",
                  attrs: { color: "purple darken-3", dark: "", "x-small": "" },
                  on: { click: _vm.generateInvoice }
                },
                [_c("span", [_vm._v("Generate Invoice")])]
              )
            : _c(
                "v-btn",
                {
                  staticClass: "mr-2",
                  attrs: { color: "error", dark: "", "x-small": "" },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        name: "orders.show",
                        params: { orderId: _vm.$route.params.orderId }
                      })
                    }
                  }
                },
                [_c("span", [_vm._v("Cancel")])]
              ),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: { color: "purple darken-3", dark: "", "x-small": "" },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "orders.table" })
                }
              }
            },
            [_c("span", [_vm._v("Orders View")])]
          ),
          _c(
            "v-btn",
            {
              attrs: {
                dark: "",
                text: "",
                "x-small": "",
                loading: _vm.orderPutting
              },
              on: { click: _vm.updateOrder }
            },
            [_c("v-icon", [_vm._v("mdi-content-save")])],
            1
          )
        ],
        1
      ),
      _c(
        "v-overlay",
        {
          attrs: { absolute: "" },
          model: {
            value: _vm.orderPutting,
            callback: function($$v) {
              _vm.orderPutting = $$v
            },
            expression: "orderPutting"
          }
        },
        [
          _c("v-progress-circular", { attrs: { indeterminate: "", size: 100 } })
        ],
        1
      ),
      _c("edit-order", {
        attrs: {
          "field-attributes": _vm.orderFieldAttributes,
          "input-fields": _vm.orderFields,
          "default-field-values": _vm.orderData,
          "error-messages": _vm.$objectChangeKeyCase(_vm.orderPutErrors)
        },
        on: {
          "update:inputFields": function($event) {
            _vm.orderFields = $event
          },
          "update:input-fields": function($event) {
            _vm.orderFields = $event
          }
        }
      }),
      _c(
        "v-toolbar",
        { attrs: { color: "primary", dense: "", dark: "", elevation: "0" } },
        [
          _c("span", [_vm._v("Details")]),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { color: "green", dark: "", "x-small": "", dense: "" },
              on: {
                click: function($event) {
                  _vm.addDetailDialog = true
                }
              }
            },
            [_c("span", [_vm._v("Add")])]
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          items: _vm.orderDetails,
          dense: "",
          headers: _vm.headers,
          "hide-default-footer": ""
        },
        scopedSlots: _vm._u([
          {
            key: "body.append",
            fn: function() {
              return [
                _c("tr", [
                  _c("td", { attrs: { colspan: "6", align: "right" } }, [
                    _c("strong", [_vm._v("Total")])
                  ]),
                  _c("td", { attrs: { align: "right" } }, [
                    _c("span", [
                      _vm._v(_vm._s((_vm.totalAmount || 0).phpFormat()))
                    ])
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.stock.description))]),
                  _c("td", [_vm._v(_vm._s((item.discount || 0).phpFormat()))]),
                  _c("td", [_vm._v(_vm._s(item.orderDetailStatusId))]),
                  _c("td", [_vm._v(_vm._s(item.dateAllocated.dateFormat()))]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(_vm._s(item.quantity))
                  ]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(_vm._s((item.unitPrice || 0).phpFormat()))
                  ]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(
                      _vm._s(
                        (
                          item.quantity * (item.unitPrice - item.discount) || 0
                        ).phpFormat()
                      )
                    )
                  ]),
                  _c(
                    "td",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            "x-small": "",
                            color: "yellow darken-3",
                            disabled:
                              _vm.orderData.status_id === "CP" &&
                              _vm.orderData.invoiceCount
                          },
                          on: {
                            click: function($event) {
                              return _vm.openEditDetailDialog(item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            "x-small": "",
                            color: "red",
                            disabled:
                              _vm.orderData.status_id === "CP" &&
                              _vm.orderData.invoiceCount,
                            loading: _vm.orderDetailDeleting
                          },
                          on: {
                            click: function($event) {
                              return _vm.deleteOrderDetail(item.id)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-delete")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      }),
      _c("edit-detail", {
        ref: "editDetail",
        attrs: {
          "order-data": _vm.orderData,
          "excluded-stocks": _vm.stocks,
          stocks: _vm.stockHasFeedDetailList,
          statuses: _vm.orderDetailStatusIndexList
        },
        model: {
          value: _vm.editDetailDialog,
          callback: function($$v) {
            _vm.editDetailDialog = $$v
          },
          expression: "editDetailDialog"
        }
      }),
      _c("create-detail", {
        attrs: {
          "order-data": _vm.orderData,
          "excluded-stocks": _vm.stocks,
          stocks: _vm.stockHasFeedDetailList,
          statuses: _vm.orderDetailStatusIndexList
        },
        model: {
          value: _vm.addDetailDialog,
          callback: function($$v) {
            _vm.addDetailDialog = $$v
          },
          expression: "addDetailDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }